export type Item = {
  title: string;
  links: Array<{
    id: string;
    url: string | undefined;
    canToggleModal?: boolean;
  }>;
};

const items: Item[] = [
  {
    title: 'menu.title',
    links: [
      {
        id: 'menu.invest-in-land',
        url: '/#invest-in-land',
      },
      {
        id: 'menu.we-do',
        url: '/#we-do',
      },
      {
        id: 'menu.why-buy',
        url: '/#why',
      },
      {
        id: 'menu.who-we-are',
        url: '/team',
      },
      // {
      //   id: 'menu.faqs',
      //   url: '/faqs',
      // },
    ],
  },
  // {
  //   title: 'menu.privacy-title',
  //   links: [
  //     {
  //       id: 'menu.cookies',
  //       url: 'https://agrotoken.notion.site/Uso-de-Cookies-y-tecnolog-as-similares-23ee818396124ab0876d5166751fd95a',
  //     },
  //     {
  //       id: 'menu.privacy',
  //       url: 'https://agrotoken.notion.site/Pol-tica-de-Privacidad-d68b3dc1cfdd4752855eb3485addc15f',
  //     },
  //   ],
  // },
  {
    title: 'helpcenter.title',
    links: [
      {
        id: 'chat_with_us',
        url: 'https://wa.me/5491125718626',
      },
      {
        id: 'simulator',
        url: 'https://app.landtoken.io/simulate-investment',
      },
      {
        id: 'helpcenter.learn',
        url: '/faqs',
      },
      {
        id: 'helpcenter.webinar',
        url: 'https://youtube.com/playlist?list=PLYyPN35KiRi6Om2c78Ns_B6UAcv0FvzTO',
      },
      {
        id: 'helpcenter.help',
        url: undefined,
        canToggleModal: true,
      },
    ],
  },
  {
    title: 'social.title',
    links: [
      {
        id: 'social.linkedIn',
        url: 'https://www.linkedin.com/company/landtoken/',
      },
      {
        id: 'social.instagram',
        url: 'https://www.instagram.com/landtoken.io',
      },
      {
        id: 'social.twitter',
        url: 'https://twitter.com/landtoken_io',
      },
    ],
  },
];

export default items;
